import * as Configuration from "../../Startup/serviceDeskConfig";

/**
 * Hey, why do we have a test hook service? Isn't it bad to have non-production code around?
 * Yes. It is. We're choosing to have this code because it's the most testable way we can offer
 *  must-have functionality needed in tests.
 */
export let dismissTransientViews = "dismissTransientViews";

/**
 * Used for rare cases where production code has to be aware of automation needs.
 */
export interface TestHookService {
  /**
   * Whether or not the current test automation wants to see transient UI.
   */
  shouldTransientViewsBeShown(): boolean;
}

export class TestHookService implements TestHookService {
  // @ngInject
  constructor(private $rootScope: ng.IRootScopeService) {
    (<any>window)._sd_testHookService = this;
  }

  /**
   * This method exists to dismiss any views which aren't considered crucial to the scenario under test. Some parts of our application
   *  (ASAT survey, logging messages, etc) can occur intermittently and shouldn't be on the screen during a test execution.
   */
  public dismissTransientViews() {
    this.$rootScope.$broadcast(dismissTransientViews, {});
  }

  public shouldTransientViewsBeShown(): boolean {
    return sessionStorage.getItem(Configuration.SuppressTransientViewsStorageKey) !== "true";
  }
}
